import React, { useMemo } from 'react'
import { dialogTypes } from '@/dialogs'
import context from '@/context'
import {
  createLookupFilterCell,
  LookupCell,
  Column,
  DateCell,
  DateFilterCell
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'

export const Licenses = React.memo(function Licenses ({ dataSource }) {
  const { localize } = useLocalization()
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.license }), [])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.Licenses}>
      <PropertyRenderer name='licenses' inputType='grid' dataSource={dataSource}
        addButtonLabel='Institutions.AddLicense' detailDialog={detailDialog}>
        <Column field='type' title={localize('Institutions.LicenseType')} cell={LookupCell}
          filterCell={createLookupFilterCell(context.cache.getLicenseTypes)} />
        <Column field='number' title={localize('Institutions.LicenseNumber')} />
        <Column field='issueDate' title={localize('Institutions.LicenseIssueDate')} filter='date' cell={DateCell} filterCell={DateFilterCell} />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/licenses.js